export default {
  SET_UNREAD_NOTICES_COUNT(state, unreadNoticesCount) {
    state.unreadNoticesCount = unreadNoticesCount;
  },
  DECREMENT_UNREAD_NOTICES_COUNT(state) {
    if (state.unreadNoticesCount > 0) {
      state.unreadNoticesCount = state.unreadNoticesCount - 1;
    }
  },
  INCREMENT_UNREAD_NOTICES_COUNT(state) {
    if (state.unreadNoticesCount >= 0) {
      state.unreadNoticesCount = state.unreadNoticesCount + 1;
    }
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  }
};
